import { getClipDrawerRequestData, getClipDrawerSnapshotData } from './redux/slice';
import { useCreateClipRequest } from 'Modules/video/.globals/api/clipRequests';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { checkDeviceData } from 'Core/data/Helpers';
import { NotificationManager } from 'Components/Notifications';
import { useIntl } from 'react-intl';

export const useClipRequestDrawer = () => {
  const dispatch = useDispatch();
  const { 
    event, 
    loading, 
    error, 
    data, 
    loadingSnapshot, 
    snapshot, 
    errorSnapshot
  } = useSelector((state) => state.clipRequestDrawerMapSlice);
  const { id, unitId, lat, lng, unitTime: eventUnitTime } = event ?? {};
  const deviceData = checkDeviceData(data?.markerDetail?.vehicleTrail?.deviceData);
  const {messages} = useIntl();
  
  const getClipRequest = async () => {
    dispatch(getClipDrawerRequestData({ id, unitId }));
  }

  const getSnapshot = async ({ unitTime, deviceId }) => {
    dispatch(getClipDrawerSnapshotData({ unitTime, deviceId }));
  }

  const { mutate: createClip, isPending: loadingCreate } = useCreateClipRequest({
    onSuccess: () => {
      NotificationManager.success(
        messages['realtimemaps_vehicletrails_clip_created_successfully'],
        messages['success'],
        3000,
        null,
        null,
        'success'
      );
    },
    onError: () => {
      NotificationManager.warning(
        messages['realtimemaps_vehicletrails_error_creating_clip'],
        messages['realtimemaps_vehicletrails_error_creating_clip_warning'],
        3000,
        null,
        null,
        'warning'
      );
    },
  });

  const createClipRequest = ({ deviceId, dateRange, isPrivate }) => {
    createClip({
      deviceId,
      dateRange,
      latitude: lat,
      longitude: lng,
      isPrivate: Boolean(isPrivate),
    });
  };

  useEffect(() => {
    if (!id || !unitId) return;
    getClipRequest();
  }, [id, unitId]);

  useEffect(() => {
    if (!data) return;
    getSnapshot({
      unitTime: data?.markerDetail?.vehicleTrail?.unitTime,
      deviceId: data?.markerDetail?.vehicleTrail?.deviceId,
    });
  }, [data]);



  return {
    id,
    loading: loading || loadingSnapshot,
    error: error || errorSnapshot,
    data: { ...data, snapshot, video: deviceData },
    createClipRequest,
    loadingCreate,
    eventUnitTime
  };
}